<div id="pdp-not-found" class="hmf-display-flex hmf-flex-column hmf-align-items-center hmf-my-l">
	<h2>404 Page Not Found</h2>
	<div class="hmf-mx-s hmf-mx-m-0">
		The page you were looking for does not exist! Click
		<a hmf-text-link
			variant="primary"
			[linkURL]="'/'"
			altText="Some alt Text"
			dataEm="PDP_notFoundTemplateReturnToHome"
			ariaLabel="Return to Homepage">
			here
		</a>
		to return to the Home Page
	</div>
</div>
